  <mat-card>
    <mat-card-content>
      <!-- Choose customer Dropdown -->
      <div fxLayout="column">
        <div class="input-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
          <app-applications></app-applications>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions align="end">

    </mat-card-actions>
  </mat-card>
<ng-template #container>

</ng-template>

<!-- Progress Bar -->
<div fxLayout="column" *ngIf="showResult">
  <section class="example-section">
  </section>
</div>

<div #scrollFrame [scrollTop]="scrollTop">
  &nbsp;
</div>
